import {createContext, useContext, type PropsWithChildren} from 'react'
import type {PromptEvalsState} from '../prompt-evals-state'

export const initialPromptEvalsState = (): PromptEvalsState =>
  ({
    selectedLanguage: 'js',
    selectedSDK: '',
    syncInputs: false,
    // model: null,
  }) as PromptEvalsState

const PromptEvalsStateContext = createContext<PromptEvalsState>(initialPromptEvalsState())

export function usePromptEvalsState() {
  return useContext(PromptEvalsStateContext)
}

export const PromptEvalsStateProvider = ({children, state}: PropsWithChildren<{state: PromptEvalsState}>) => {
  return <PromptEvalsStateContext.Provider value={state}>{children}</PromptEvalsStateContext.Provider>
}

try{ PromptEvalsStateContext.displayName ||= 'PromptEvalsStateContext' } catch {}
try{ PromptEvalsStateProvider.displayName ||= 'PromptEvalsStateProvider' } catch {}